import { m } from '@sohanscript/i18n';
import { PageHero } from '@sohanscript/ui/page-hero';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { GoToTop } from '#/components/layout/goto-top.tsx';
import { WorksInfiniteList } from '@/components/works/works-infinite-list';
import { seo, siteConfig } from '@/lib/config/site';

export const Route = createFileRoute('/_main/works')({
	component: WorksPage,
	async loader({ context }) {
		await context.trpc.project.list.ensureData({ cursor: 1, perPage: 4 });
	},
	head: () => {
		const tags = seo({
			title: m.nav_works(),
			description: m.works_seo_desc(),
			url: `${siteConfig.canonical}/works`,
		});
		return { meta: tags.meta, links: tags.links };
	},
});

function WorksPage() {
	return (
		<section className="container mx-auto pt-10 pb-20 lg:py-20">
			<PageHero
				path="works"
				status="[STATUS: SHIPPED]"
				sub={m.works_header_tagline()}
				meta={m.works_heading_tagline()}
				metaRight="BUILD: PRODUCTION // 0xSHIP"
			>
				{m.works_header_label()}
			</PageHero>
			<Suspense
				fallback={
					<div className="flex justify-center py-5 lg:py-20">
						<div className="size-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
					</div>
				}
			>
				<WorksInfiniteList />
			</Suspense>
			<GoToTop />
		</section>
	);
}
